var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ehc-page',[_c('ehc-organization',{model:{value:(_vm.orgID),callback:function ($$v) {_vm.orgID=$$v},expression:"orgID"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }